import { JobType } from '../redux/jobs/jobs.types';
import { AssignmentPresetType } from '../redux/login/login.types';

export interface MeterChangeInfo {
    jobId: string;
    meLoId: string;
    storedMeterNumbers: string[];
    currentMeterNumber?: string;
}

export interface PresetMatchResult {
    matchedIds: string[];
    meterChangedIds: string[];
    meterChangeInfos: MeterChangeInfo[];
}

export const matchPreset = (jobs: JobType[], preset: AssignmentPresetType): PresetMatchResult => {
    // Build MeLo -> set of meter numbers from the preset filter (ignore entries without a MeLo).
    const meLoToMeters = new Map<string, Set<string>>();
    (preset.filter ?? []).forEach((entry) => {
        if (!entry.meLoId) return;
        const set = meLoToMeters.get(entry.meLoId) ?? new Set<string>();
        if (entry.meterNumber) set.add(entry.meterNumber);
        meLoToMeters.set(entry.meLoId, set);
    });

    const matchedIds: string[] = [];
    const meterChangedIds: string[] = [];
    const meterChangeInfos: MeterChangeInfo[] = [];

    jobs.forEach((job) => {
        const meLoId = job.meter?.meLoId;
        if (!meLoId || !meLoToMeters.has(meLoId)) return; // no MeLo match -> nothing

        matchedIds.push(job.id);

        const knownMeters = meLoToMeters.get(meLoId) as Set<string>;
        const meterNumber = job.meter?.meterNumber;
        if (!meterNumber || !knownMeters.has(meterNumber)) {
            meterChangedIds.push(job.id); // MeLo matched but meter number differs
            meterChangeInfos.push({
                jobId: job.id,
                meLoId,
                storedMeterNumbers: Array.from(knownMeters),
                currentMeterNumber: meterNumber,
            });
        }
    });

    return { matchedIds, meterChangedIds, meterChangeInfos };
};
